import React from "react";
import { HiOutlineMap } from "react-icons/hi2";
import { IoMdClose } from "react-icons/io";

// components
import Button from "@/shared/Button";

// interfaces
import { IShowMapButton } from "../ISearchResultsPageComponent";

// assets
import styles from "@/assets/styles/pages/search-results.module.scss";

const ShowMapButton = ({ onClick, isMapShown = false, ...rest }: IShowMapButton) => {
  const buttonData = isMapShown
    ? <span className={styles["locl-search-results__cards__controls__map__content"]}>Hide map <IoMdClose/></span>
    : <span className={styles["locl-search-results__cards__controls__map__content"]}>Show map <HiOutlineMap/></span>;

  return (
    <Button
      className={styles["locl-search-results__cards__controls__map"]}
      type="secondary"
      onClick={onClick}
      { ...rest }
    >
      {buttonData}
    </Button>
  );
};

export default ShowMapButton;
